<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">Detalji slidera</h2>
                  <p class="card-big-info-desc">Unesite detalje slidera</p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.internalTitle.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naziv
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="internalTitle"
                      />
                      <form-error
                        :model="$v.internalTitle"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naslov
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naslov"
                        v-model="title"
                      />
                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        label="Naslov"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Velicina fonta naziva
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Velicina fonta naziva"
                        v-model="titleFontSize"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja teksta naziva
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="titleColour"
                            :swatches="swatches"
                            show-border
                            popover-x="left"
                            inline
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Glavni opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Glavni opis"
                        v-model="mainDescription"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Velicina fonta glavnog opisa
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Velicina fonta glavnog opisa"
                        v-model="mainDescriptionFontSize"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja teksta glavnog opisa
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="mainDescriptionColour"
                            :swatches="swatches"
                            show-border
                            popover-x="left"
                            inline
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sporedni opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Sporedni opis"
                        v-model="secondaryDescription"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Velicina fonta sporednog opisa
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Velicina fonta sporednog opisa"
                        v-model="secondaryDescriptionFontSize"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja teksta sporednog opisa
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="secondaryDescriptionColour"
                            :swatches="swatches"
                            show-border
                            popover-x="left"
                            inline
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Fusnota
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Fusnota"
                        v-model="fusnote"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Link
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Link"
                        v-model="contentUrl"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Link tekst
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Link tekst"
                        v-model="linkText"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Vidljivo na webu?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          id="visible-on-web"
                          name="agreeterms"
                          type="checkbox"
                          v-model="isVisibleOnWeb"
                        />
                        <label
                          class="control-label"
                          for="visible-on-web"
                        ></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Zadani sadržaj?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          id="default-content"
                          name="agreeterms"
                          type="checkbox"
                          v-model="isDefaultContent"
                        />
                        <label
                          class="control-label"
                          for="default-content"
                        ></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Poravnanje
                    </label>

                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="alignment"
                        :multiple="false"
                        :options="alignments"
                        placeholder="Izaberite poravnanje"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Djelatnosti
                    </label>

                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="jumbotronInterestsAreas"
                        :multiple="true"
                        :options="areas"
                        placeholder="Izaberite djelatnost"
                        v-if="areas"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dostupno na</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="jumbotronContentType"
                      >
                        <option
                          v-for="item in b2borb2cOptions"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div v-if="jumbotronContentType == 1 || jumbotronContentType == 3"
                  class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Redoslijed prikaza B2B
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="number"
                        class="form-control form-control-modern"
                        placeholder="Redoslijed prikaza"
                        v-model.number="displayOrder"
                        @input="validateDisplayOrder"
                      />
                    </div>
                  </div>

                  <div v-if="jumbotronContentType == 2 || jumbotronContentType == 3"
                  class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Redoslijed prikaza B2C
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="number"
                        class="form-control form-control-modern"
                        placeholder="Redoslijed prikaza"
                        v-model.number="displayOrderB2C"
                        @input="validateDisplayOrderB2C"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika desktop slidera</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        @change="handlePhotoUpload"
                        accept="image/*"
                      />
                      <div class="form-text">
                        Učitajte sliku rezolucije 1110px x 455px
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sirina slike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Širina slike"
                        v-model="imagePxWidth"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Visina slike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Visina slike"
                        v-model="imagePxHeight"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika mobilnog slidera</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="mobilePhoto"
                        @change="handleMobilePhotoUpload"
                        accept="image/*"
                      />
                      <div class="form-text">
                        Učitajte sliku rezolucije 920px x 1215px
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sirina slike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Širina slike"
                        v-model="mobileImagePxWidth"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Visina slike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Visina slike"
                        v-model="mobileImagePxHeight"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <div class="col-12">
                      <div
                        class="home-slide"
                        :style="{
                          backgroundImage: `url(${posterUrl})`,
                        }"
                      >
                        <div
                          class="slide-content"
                          :class="`content-${alignment}`"
                        >
                          <div class="text-wrapper">
                            <h2
                              :class="`text-${alignment}`"
                              :style="{ color: titleColour, fontSize: titleFontSize + 'px' }"
                              v-if="title"
                            >
                              {{ title }}
                            </h2>
                            <div
                              class="skew-box-group"
                              v-if="secondaryDescription || mainDescription"
                            >
                              <span
                                class="skew-box"
                                :style="{
                                  color: mainDescriptionColour,
                                  fontSize: mainDescriptionFontSize + 'px'
                                }"
                                v-if="mainDescription"
                              >
                                {{ mainDescription }}
                              </span>
                              <span
                                class="skew-box"
                                :style="{
                                  color: secondaryDescriptionColour,
                                  fontSize: secondaryDescriptionFontSize + 'px'
                                }"
                                v-if="secondaryDescription"
                              >
                                {{ secondaryDescription }}
                              </span>
                            </div>
                          </div>
                          <a
                            v-if="contentUrl"
                            :href="contentUrl"
                            class="btn btn-light text-primary font-weight-bold bottom-absolute"
                            target="_blank"
                          >
                            {{ linkText || contentUrl }}
                          </a>
                        </div>
                        <p v-if="fusnote">* {{ fusnote }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="form-group row align-items-center mb-3">
                    <div class="col-12">
                      <div
                        class="home-slide"
                        :style="{
                          backgroundImage: `url(${mobilePosterUrl})`,
                        }"
                      >
                        <div
                          class="slide-content"
                          :class="`content-${alignment}`"
                        >
                          <div class="text-wrapper">
                            <h2
                              :class="`text-${alignment}`"
                              :style="{ color: titleColour, fontSize: titleFontSize + 'px' }"
                              v-if="title"
                            >
                              {{ title }}
                            </h2>
                            <div
                              class="skew-box-group"
                              v-if="secondaryDescription || mainDescription"
                            >
                              <span
                                class="skew-box"
                                :style="{
                                  color: mainDescriptionColour,
                                  fontSize: mainDescriptionFontSize + 'px'
                                }"
                                v-if="mainDescription"
                              >
                                {{ mainDescription }}
                              </span>
                              <span
                                class="skew-box"
                                :style="{
                                  color: secondaryDescriptionColour,
                                  fontSize: secondaryDescriptionFontSize + 'px'
                                }"
                                v-if="secondaryDescription"
                              >
                                {{ secondaryDescription }}
                              </span>
                            </div>
                          </div>
                          <a
                            v-if="contentUrl"
                            :href="contentUrl"
                            class="btn btn-light text-primary font-weight-bold bottom-absolute"
                            target="_blank"
                          >
                            {{ linkText || contentUrl }}
                          </a>
                        </div>
                        <p v-if="fusnote">* {{ fusnote }}</p>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div
          class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
        >
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            exact
            :to="{ name: 'Sliders' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import VSwatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.css';

import { translations } from '@/mixins';
import api from '@/services/api';
import config from '@/config';
import validations from './validation-schema/add';
import FormError from '../../shared/form-errors/FormError.vue';

export default {
  name: 'EditSlider',
  mixins: [translations],
  validations,
  components: {
    VSwatches,
    Treeselect,
    FormError,
  },
  data() {
    return {
      jumbotronContentType: 3,
      b2borb2cOptions: [
        {
          id: 1,
          text: 'B2B',
        },
        {
          id: 2,
          text: 'B2C',
        },
        {
          id: 3,
          text: 'Sve',
        },
      ],
      swatches: ['#0088CC', '#fff', '#212529'],
      alignments: [
        {
          id: 'left-up',
          label: 'Lijevo gore',
        },
        {
          id: 'left-down',
          label: 'Lijevo dole',
        },
        {
          id: 'right-up',
          label: 'Desno gore',
        },
        {
          id: 'right-down',
          label: 'Desno dole',
        },
      ],
      internalTitle: '',
      title: '',
      titleFontSize: '',
      titleColour: '#fff',
      mainDescription: '',
      mainDescriptionColour: '#fff',
      mainDescriptionFontSize: '',
      secondaryDescription: '',
      secondaryDescriptionColour: '#fff',
      secondaryDescriptionFontSize: '',
      alignment: 'left-up',
      contentUrl: '',
      baseUrl: config.baseUrl,
      fusnote: '',
      displayOrder: 100,
      displayOrderB2C: 100,
      linkText: '',
      isVisibleOnWeb: false,
      isDefaultContent: false,
      jumbotronInterestsAreas: [],
      imagePxWidth: '',
      imagePxHeight: '',
      posterUrl: '',
      mobilePosterUrl: '',
      mobileImagePxWidth: '',
      mobileImagePxHeight: '',
    };
  },
  computed: {
    slider() {
      return this.$store.getters.getJumbotron;
    },
    areas() {
      return this.$store.getters.getInterestsAreas.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        this.$nextTick(() => {
          const elem = document.querySelector('.has-danger');
          if (elem) {
            elem.scrollIntoView(true);
          }
        });
        return;
      }

      if (!this.mobileImagePxWidth || !this.mobileImagePxHeight) {
        this.$toast.error(
          'Molimo učitajte sliku mobilnog slidera. Širina i visina mobilne slike su obavezni podaci i popunjavaju se automatski nakon učitavanja slike.'
        );
        return;
      }

      const {
        title,
        internalTitle,
        mainDescription,
        secondaryDescription,
        alignment,
        contentUrl,
        fusnote,
        displayOrder,
        displayOrderB2C,
        linkText,
        isVisibleOnWeb,
        isDefaultContent,
        jumbotronInterestsAreas,
        imagePxWidth,
        imagePxHeight,
        titleColour,
        titleFontSize,
        mainDescriptionColour,
        mainDescriptionFontSize,
        secondaryDescriptionColour,
        secondaryDescriptionFontSize,
        jumbotronContentType,
        mobileImagePxWidth,
        mobileImagePxHeight,
      } = this;

      const formData = new FormData();
      formData.append('title', title || '');
      formData.append('titleColour', titleColour || '');
      formData.append('titleFontSize', titleFontSize || '');
      formData.append('internalTitle', internalTitle || '');
      formData.append('mainDescription', mainDescription || '');
      formData.append('mainDescriptionColour', mainDescriptionColour || '');
      formData.append('mainDescriptionFontSize', mainDescriptionFontSize || '');
      formData.append('secondaryDescription', secondaryDescription || '');
      formData.append('secondaryDescriptionColour', secondaryDescriptionColour || '');
      formData.append('secondaryDescriptionFontSize', secondaryDescriptionFontSize || '');
      formData.append('alignment', alignment || '');
      formData.append('contentUrl', contentUrl || '');
      formData.append('fusnote', fusnote || '');
      formData.append('displayOrder', displayOrder || 1);
      formData.append('displayOrderB2C', displayOrderB2C || 1);
      formData.append('linkText', linkText || '');
      formData.append('isVisibleOnWeb', isVisibleOnWeb || false);
      formData.append('isDefaultContent', isDefaultContent || false);
      formData.append('jumbotronContentType', jumbotronContentType);

      jumbotronInterestsAreas.forEach((item) => {
        formData.append('interestsAreasIds', item);
      });

      if (this.$refs.photo.files[0]) {
        formData.append('image', this.$refs.photo.files[0]);
        formData.append('imagePxWidth', imagePxWidth);
        formData.append('imagePxHeight', imagePxHeight);
      }

      if (this.$refs.mobilePhoto.files[0]) {
        formData.append('mobileImage', this.$refs.mobilePhoto.files[0]);
        formData.append('mobileImagePxWidth', mobileImagePxWidth);
        formData.append('mobileImagePxHeight', mobileImagePxHeight);
      }

      api.createJumbotron(formData).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'Sliders' });
      });
    },
    validateDisplayOrder() {
      if (this.displayOrder < 1) {
        this.displayOrder = 1;
      }
    },
    validateDisplayOrderB2C() {
      if (this.displayOrderB2C < 1) {
        this.displayOrderB2C = 1;
      }
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = (e) => {
        this.imagePxWidth = e.target.width;
        this.imagePxHeight = e.target.height;
        this.posterUrl = img.src;
      };
    },
    handleMobilePhotoUpload() {
      const file = this.$refs.mobilePhoto.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = (e) => {
        this.mobileImagePxWidth = e.target.width;
        this.mobileImagePxHeight = e.target.height;
        this.mobilePosterUrl = img.src;
      };
    },
  },
  mounted() {
    this.$store.dispatch('getInterestsAreas', {
      retrieveAll: true,
      sortBy: 'title',
    });
  },
};
</script>
<style lang="scss" scoped>
@import './sliders.scss';
</style>
